<template>
    <Page>
        <div class="max-h-[78%] bg-white !min-w-[100vw]">
            <div class="absolute top-0 left-0 h-full w-1/2 bg-[#f7f7f7]" />
            <Image src="/CaseStudy/info-graphic.jpg"
                 class="h-full object-cover mx-auto overflow-hidden" />
        </div>
    </Page>
</template>